import { apiClient } from './client'

/**
 * Registry schema returned from /api/advanced/registry.
 * Each key is a category ID (e.g. "nomenclature", "tasks", "constants").
 */
export interface RegistryColumn {
  key: string
  label: string
  code?: boolean
  type?: 'date' | 'bool'
  badge?: Record<string, string>
}

export interface RegistryFilter {
  value: string
  label: string
}

export interface RegistryEntry {
  title: string
  tab: string
  tab_title: string
  tab_order: number
  id_field: string
  deletable: boolean
  render_type: 'table' | 'constants' | 'sidebar'
  columns: RegistryColumn[]
  filters?: RegistryFilter[]
}

export type Registry = Record<string, RegistryEntry>

export interface SidebarItem {
  icon: string
  label: string
  endpoint: string
  match: string[]
}

export interface SidebarData {
  admin: SidebarItem[]
  worker: SidebarItem[]
}

export const advancedApi = {
  /** Get the full object registry schema (tabs, columns, render types). */
  getRegistry: () =>
    apiClient.get<Registry>('/api/advanced/registry'),

  /** Load data for any category. Returns { items, category } for table, or raw data for constants/sidebar. */
  getCategory: (category: string, params?: Record<string, string>) =>
    apiClient.get(`/api/advanced/${category}`, { params }),

  /** Delete an item from a deletable category. */
  deleteItem: (category: string, itemId: string) =>
    apiClient.delete(`/api/advanced/${category}/${encodeURIComponent(itemId)}`),

  /** Save constants (SSCC counters, settings, etc.). */
  saveConstants: (key: string, value: unknown) =>
    apiClient.put('/api/advanced/constants', { key, value }),

  /** Save sidebar navigation config. */
  saveSidebar: (data: SidebarData) =>
    apiClient.put('/api/advanced/sidebar', data),
}
